module.exports = "/components/components/premiumDiscoveryPopupComponent-ca3680.html";